import { render, staticRenderFns } from "./MahnungErstellenModal.vue?vue&type=template&id=77386944"
import script from "./MahnungErstellenModal.vue?vue&type=script&lang=js"
export * from "./MahnungErstellenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports